export default __webpack_public_path__ + "static/VitruvianAgency-4e69ac00ce546cd5791817e3bf548ae4.mp4";